import { fieldLabel } from '../field-label'

export function requiredRule(field) {
  return [
    field,
    `${fieldLabel(field)} is required`,
    v => !!v.form[field]
  ]
}
